import Signup from './Signup';
const signupUsers = {
  signup: Signup,
};

export default signupUsers;
